export default __webpack_public_path__ + "static/media/team-pic-temp2.4215aec3.png";